export default __webpack_public_path__ + "static/media/logo-transparent-black-text.f47c09ec.png";